<template>
	<b-row>

		<b-col lg="3" md="4">
			<auto-form  v-model="currentID" origin="define/source/vendedores"  title="Alta del vendedor" />
		</b-col>

		<b-col md="8" lg="9" v-if="currentID"> 
			<pedidos-quick-table header="Pedidos" :vendedores-id="currentID" :per-page="5" :filtrosDisponibles="['Entregado','Nuevo','Preparando','En espera de repa','En espera de recolección','En ruta','Cancelado']"/>
			<fichaspago-quick-table header="Fichas de pago" :vendedores-id="currentID"/>
		</b-col>

	</b-row>
</template>

<script>
import pedidosQuickTable from "@/views/Pedidos/Concept/quicktable.vue";
import fichaspagoQuickTable from '@/views/Fichaspago/Concept/quicktable.vue';

export default {
	components: { pedidosQuickTable, fichaspagoQuickTable },
	data() {
		return {
			currentID: null,
		};
	},
	beforeMount() {
		this.currentID = this.$route.params.id;
	},
};
</script>
